module.exports = __webpack_public_path__ + "img/ANTENNA TWIRL LIME.e592e5e.svg";